<template>
  <div>
    <v-btn @click="open()" icon text>
      <v-icon> mdi-tooltip-edit </v-icon>
    </v-btn>
    <v-navigation-drawer
      app
      temporary
      right
      disable-resize-watcher
      width="650px"
      v-model="show"
      class="actionDrawer"
    >
      <v-card flat>
        <v-card-text class="pt-0">
          <v-row class="mx-4 mt-4" justify="center" align="center">
            <v-col class="text-left" cols="2">
              <v-btn @click="cancelOperation()" color="primary" icon>
                <v-icon>mdi-arrow-left-bold-circle</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="8" class="text-center">
              <v-img
                :src="this.$store.state.agency.agencyLogo"
                width="280px"
                class="mx-auto"
              />
            </v-col>
            <v-col cols="2">
              <v-btn
                v-if="
                  newPages != '' && newPages.length != subscriptionPages.length
                "
                rounded
                dense
                fab
                small
                @click="editPages()"
                color="primary"
              >
                <v-icon>mdi-history</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-12 text-center">
              <v-form ref="form" v-model="valid">
                <div class="px-4">
                  <v-row>
                    <!-- default heading -->
                    <v-col
                      v-if="overlayEdit == true"
                      cols="12"
                      class="text-center"
                    >
                      <h2>Edit Subscription Details</h2>
                    </v-col>
                    <!-- when you click edit pages -->
                    <v-col
                      v-if="overlayEdit == false"
                      cols="12"
                      class="text-center"
                    >
                      <h2 v-if="packageTitle == 'Package 1'">Editing Guardian Package</h2>
                      <h2 v-if="packageTitle == 'Package 2'">Editing Sppark Package</h2>
                      <h2 v-if="packageTitle == 'Package 3'">Editing Pulse Package</h2>
                    </v-col>

                    <v-col
                      v-if="
                        (packageTitle == 'Package 1' &&
                          newPages.length < 5 &&
                          newPages.length != '') ||
                        (packageTitle == 'Package 3' &&
                          newPages.length < 5 &&
                          newPages.length != '')
                      "
                      cols="12"
                      class="text-center"
                    >
                      <h3>
                        You can add
                        {{ pagesToAdd - this.newPages.length }} more
                        competitor(s)...
                      </h3>
                    </v-col>
                    <!-- <v-col
                      cols="12"
                      v-if="
                        (packageTitle == 'Package 2' && this.newPages != '') ||
                        (packageTitle == 'Package 5' &&
                          this.newPages.length > 5)
                      "
                      class="text-center"
                    >
                      <h3>You can add as many Competitors.</h3>
                    </v-col> -->
                    <!-- <v-col
                      v-if="
                        (newPages.length == 5 && packageTitle == 'Package 1') ||
                        (newPages.length == 5 && packageTitle == 'Package 4')
                      "
                      cols="12"
                      class="py-2"
                    >
                      <v-row justify="center" align="center">
                        <v-col cols="7" sm="7" md="6" lg="6" class="text-right">
                          <h3 style="padding: 10px">Upgrade Package?</h3>
                        </v-col>
                        <v-col cols="5" sm="5" md="6" lg="6" class="text-left">
                          <v-btn
                            @click="upgradePackage()"
                            rounded
                            small
                            dense
                            style="padding: 10px"
                            class="primary white--text hidden-sm-and-down"
                          >
                            Upgrade Now
                          </v-btn>
                          <v-btn
                            @click="upgradePackage()"
                            rounded
                            small
                            dense
                            text
                            style="padding: 10px"
                            class="primary white--text hidden-md-and-up"
                          >
                            Upgrade
                            <v-icon>mdi-arrow-up-bold-circle</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col> -->
                    <v-col
                      v-if="overlayEdit == false"
                      cols="12"
                      class="text-center pt-3"
                    >
                      <h3 class="danetest--text">Subscription Pages</h3>
                    </v-col>

                    <v-col
                      v-if="
                        (overlayEdit == false && newPages.length < 5)
                      "
                      class="col-12 py-0"
                    >
                      <v-menu offset-y open-on-click>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            type="text"
                            class="facebookHandleInput"
                            v-model="search"
                            :placeholder="dynamicLabel"
                            @keyup="searchForCompany()"
                            v-on="on"
                            v-bind="attrs"
                            :loading="loadingSearch"
                          />
                        </template>

                        <v-list class="listofpages" v-if="!loadingSearch">
                          <v-list-item
                            v-if="this.search == '' && !loadingSearch"
                          >
                            <v-list-item-title
                              >Type clients facebook page name or paste clients
                              facebook url
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-for="searchResult in searchResults"
                            :key="searchResult.id"
                            @click="selectCompany(searchResult)"
                          >
                            <v-avatar size="40" class="mr-2">
                              <v-img :src="searchResult.icon" />
                            </v-avatar>
                            <v-list-item-title>
                              {{ searchResult.name }}</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                        <v-list v-if="this.searchPageError">
                          <v-list-item>
                            <v-list-item-title
                              >{{ searchErrorMessage }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                        <v-list v-if="loadingSearch">
                          <v-list-item>
                            <v-list-item-title
                              >Please Wait, pages are logging
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              >
                              </v-progress-circular
                            ></v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>

                    <v-col cols="12">
                      <v-card flat>
                        <!-- List Group For Current Subscription -->
                        <v-list v-if="overlayEdit == true">
                          <v-list-item
                            class="py-2"
                            v-for="page in subscriptionPages"
                            :key="page.id"
                          >
                            <v-avatar size="40" class="mr-2">
                              <img :src="page.icon" alt="John" />
                            </v-avatar>
                            <v-list-item-content class="text-left">
                              <v-list-item-title>{{
                                page.name
                              }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <!-- List Group For Edit Subscription -->
                        <v-list v-if="overlayEdit == false">
                          <v-list-item
                            class="py-2"
                            v-for="(newPages, index) in newPages"
                            :key="newPages.id"
                          >
                            <v-avatar size="40" class="mr-2">
                              <img :src="newPages.icon" alt="John" />
                            </v-avatar>
                            <v-list-item-content class="text-left">
                              <v-list-item-title>{{
                                newPages.name
                              }}</v-list-item-title>
                            </v-list-item-content>
                            <v-btn
                              v-if="index != 0"
                              @click="deletePage(index)"
                              icon
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-list-item-content v-if="index == 0">
                              <v-list-item-title>
                                - Primary page
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-overlay :absolute="absolute" :value="overlayEdit">
                          <v-btn color="primary" @click="editPages()">
                            <v-icon>mdi-pencil</v-icon>
                            Edit Pages
                          </v-btn>
                        </v-overlay>
                      </v-card>
                    </v-col>
                    <!-- <v-btn @click="testsearch()">Test</v-btn> -->
                  </v-row>
                  <v-row v-if="overlayEdit == false" class="actionsbuttons">
                    <v-col cols="6" class="text-center">
                      <v-btn
                        small
                        rounded
                        @click="cancelOperation()"
                        class="compeatsecondary white--text"
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                    <v-col cols="6" class="text-center">
                      <v-btn
                        small
                        :loading="loading"
                        :disabled="!valid"
                        rounded
                        @click="updateSubscription()"
                        class="primary white--text"
                      >
                        Submit
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="120">
          <p class="mb-0 overlaytext">Please Wait...</p>
        </v-progress-circular>
      </v-overlay>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../../firebaseConfig";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  getDoc,
  doc,
} from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default {
  props: [
    "subscription",
    "subscriptionPages",
    "subscriptionPackage",
    "successAlert",
  ],
  data: () => ({
    //Side popup varibles
    show: false,
    overlayEdit: true,
    absolute: true,
    overlay: false,

    loading: false,

    // Validation and rules for form
    valid: false,
    rules: { required: (value) => !!value || "Required." },
    checkboxRules: [
      (v) => !!v || "I agree to the terms & conditions must be checked",
    ],

    //Search Companies
    searchResults: [],
    search: "",
    attrs: true,
    on: true,
    loadingSearch: false,

    // packages varibles
    packagePages: [],
    pagesToAdd: 5,
    quantity: 0,
    packageTitle: "",
    priceTotal: 0,
    upgradePackageTwo: false,
    upgradePackageFive: false,

    // form data
    checkbox: false,

    // Allert varibles
    alert: false,
    alertType: "",
    successResponse: "",

    // Error varibles
    searchPageError: false,
    searchErrorMessage: "",

    //New array for pages array
    newPages: [],
  }),
  computed: {
    // dynamic labling for the search field
    dynamicLabel() {
      if (this.newPages.length !== 0) {
        return "Competitor pages";
      } else {
        // Provide a default label when packagePages.length is 0
        return "Client Facebook Page";
      }
    },
  },
  methods: {
    // Open New Subscribtion Drawer and display over Layer
    open() {
      this.show = !this.show;
    },
    // Adds pages from packagePages array and changes searchResults to false
    selectCompany(facebookpage) {
      this.newPages.push(facebookpage);
      this.searchResults = [];
      this.search = "";
      this.focus = false;
    },
    // Edit pages
    editPages() {
      this.overlayEdit = false;
      this.newPages = [...this.subscription.package.pages];
      this.checkbox = false;

      if (this.subscriptionPackage == "Package 1") {
        this.package1();
      } else if (this.subscriptionPackage == "Package 2") {
        this.package2();
      } else if (this.subscriptionPackage == "Package 3") {
        this.package3();
      } 
    },
    // delete pages from packagePages array
    deletePage(index) {
      this.newPages.splice(index, 1);
    },
    // seach for company pages
    searchForCompany() {
      this.loadingSearch = true;
      this.searchPageError = false;
      if (this.search.length < 2) {
        this.searchResults = [];
        return; // Do not search until at least two characters are entered
      } else if (this.search.length > 0) {
        this.searchResults = [];
      }

      const functions = getFunctions(firebaseApp, "europe-west2");
      const searchFacebookPage = httpsCallable(functions, "searchFacebookPage");

      const currentSearchQuery = this.search;

      searchFacebookPage({
        query: this.search,
        fbToken: this.$store.state.user.facebookToken,
      })
        .then((result) => {
          this.loadingSearch = true;
          // Check if the search query has changed since the search request was made
          if (this.search === currentSearchQuery) {
            let searchpages = result.data.response.pageData;

            // Clear previous search results
            this.searchResults = [];
            // Add new search results
            this.searchResults.push(...searchpages);
            this.focus = true;
          }
        })
        .then(() => {
          this.loadingSearch = false;
        })
        .catch((error) => {
          console.log(error);
          this.searchPageError = true;
          this.searchErrorMessage = "Something went wrong please try again";
        })
        .finally(() => {
          this.loadingSearch = false;
        });
    },
    //Checks to  see which subscription package its updating to
    updateSubscription() {
      switch (true) {
        // case this.upgradePackageTwo:
        //   this.loading = true;
        //   this.updatePackage();
        //   break;
        // case this.upgradePackageFive:
        //   this.loading = true;
        //   this.updatePackage();
        //   break;
        // case this.upgradePackageThree:
        //     console.log('Upgrade to package 3');
        //     break;
        // case this.downgradeToPackageOne:
        //   console.log("Downgrade To Package 1");
        //   this.loading = true;
        //   this.upgradeSubscriptionPackage();
        //   break;
        default:
          this.loading = true;
          this.updatePagesOnly();
          break;
      }
    },
    // update Pages only
    async updatePagesOnly() {
      this.overlay = true;
      try {
        // Remove the 'isNew' property from each object in the 'newPages' array
        const pages = this.newPages;

        const docRef = doc(db, "subscriptions", this.subscription.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          // Update the 'pages' array within the document's 'package' sub-array
          const packageData = docSnap.data().package;
          const updatedPackageData = { ...packageData, pages };

          await updateDoc(docRef, {
            package: updatedPackageData,
          });

          let message = "Package Pages were updated!";
          let updateType = "Pages";
          this.emailUsers(message, updateType);
        } else {
          // docSnap.data() will be undefined in this case
          console.log("No such document!");
        }
      } catch (error) {
        console.log(error);
      }
    },
    //upgrade Package
    async updatePackage() {
      this.overlay = true;
      try {
        // Remove the 'isNew' property from each object in the 'newPages' array
        const pages = this.newPages;

        const currentPackage = this.packageTitle;
        const quantity = this.quantity;
        let priceTotal = "";

        if (this.packageTitle == "Package 1") {
          priceTotal = this.priceTotal;
        } else if (
          this.packageTitle == "Package 2" ||
          this.packageTitle == "Package 5"
        ) {
          const extraUnits = Math.max(this.newPages.length - 5, 0);
          const extraPrice = extraUnits * 10;
          priceTotal = this.priceTotal + extraPrice;
        }

        const docRef = doc(db, "subscriptions", this.subscription.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          // Update the 'pages' array within the document's 'package' sub-array
          const packageData = docSnap.data().package;
          const updatedPackageData = {
            ...packageData,
            pages,
            currentPackage,
            priceTotal,
            quantity,
          };

          await updateDoc(docRef, {
            package: updatedPackageData,
          });

          let updateType = "Package";
          let message = "Package was upgraded to " + currentPackage;
          this.emailUsers(message, updateType);
        } else {
          // docSnap.data() will be undefined in this case
          console.log("No such document!");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async emailUsers(message, updateType) {
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const emailPackageChange = httpsCallable(
          functions,
          "emailPackageChange"
        );

        emailPackageChange({
          subscription: this.subscription,
          agency: this.$store.state.agency,
          packagePages: this.newPages,
          updateType: updateType,
          packageTitle: this.packageTitle,
          primaryPage: this.newPages[0],
        })
          .then((result) => {
            console.log('result', result)
            if (result.data.response.success == true) {
              this.overlay = false;
              this.alertType = "success";
              this.successResponse = message;
              // this.show = false
              this.cancelOperation();
              this.$emit("successAlert", this.successResponse, this.alertType);
            }
            // this.competitiveReportUid = result.data.reportUid;
            // this.emailAdmins();
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    //Package 1 setup
      package1() {
      this.packageTitle = "Package 1";
      this.priceTotal = 50;
      this.pagesToAdd = 5;
      this.competitiveReportData = true;
      this.insightsReportData = false;
    },
    //Package 2 setup
    package2() {
      this.packageTitle = "Package 2";
      this.priceTotal = 150;
      this.insightsReportData = true;
      //   this.getAdsAccountsForPage();
    },
    //Package 3 setup
    package3() {
      this.packageTitle = "Package 3";
      this.priceTotal = 185;
      this.pagesToAdd = 5;
      this.competitiveReportData = true;
      this.insightsReportData = false;
    },
    // //Package 1 setup
    // package1() {
    //   this.quantity = 1;
    //   this.packageTitle = "Package 1";
    //   this.priceTotal = 50;
    //   this.pagesToAdd = 5;
    //   this.plan = "price_1NpVWEAGtLYXowcOgFpzxsYG";
    // },
    // //Package 2 setup
    // package2() {
    //   this.packageTitle = "Package 2";
    //   this.quantity = 1;
    //   this.priceTotal = 50;
    //   this.pagesToAdd = 5;
    //   this.plan = "price_1NpWIJAGtLYXowcOQzWJX54H";
    //   this.plan2 = "price_1NpWKzAGtLYXowcO4Q4dnOoz";
    // },
    // //Package 3 setup
    // package3() {
    //   this.quantity = 1;
    //   this.packageTitle = "Package 3";
    //   this.priceTotal = 150;
    //   this.plan = "price_1NpoUOAGtLYXowcOua2BpEVi";
    // },
    // //Package 4 setup
    // package4() {
    //   this.quantity = 1;
    //   this.packageTitle = "Package 4";
    //   this.priceTotal = 185;
    //   this.pagesToAdd = 5;
    //   this.plan = "price_1NxPKqAGtLYXowcOKdxYmJNR";
    // },
    // //Package 5 setup
    // package5() {
    //   this.packageTitle = "Package 5";
    //   this.quantity = 1;
    //   this.priceTotal = 50;
    //   this.pagesToAdd = 5;
    //   this.plan = "price_1NpWIJAGtLYXowcOQzWJX54H";
    //   this.plan2 = "price_1NpWKzAGtLYXowcO4Q4dnOoz";
    // },
    // Formats Number for input field mobile
    onInput(formattedNumber, { number }) {
      this.mobile = number.international;
    },
    // Upgrades package to Package 2
    upgradePackage() {
      if (this.packageTitle == "Package 1") {
        this.upgradePackageTwo = true;
        this.package2();
      } else if (this.packageTitle == "Package 4") {
        this.upgradePackageFive = true;
        this.package5();
      }
    },
    // Upgrades package to Package 3
    agreeToPackageThree() {
      this.upgradePackageThree = true;
      this.package3();
    },
    // Valids Form
    validate() {
      this.$refs.form.validate();
    },
    // closes the drawer and changes over lay to false
    cancelOperation() {
      this.show = false;
      this.overlayEdit = true;
      this.overlay = false;
      this.checkbox = false;
      this.newPages = [];
      this.upgradePackageTwo = false;
      this.upgradePackageFive = false;
      this.downgradeToPackageOne = false;
      this.upgradePackageThree = false;
    },
  },
};
</script>

<style>
.actionDrawer {
  border-radius: 50px 0px 0px 50px !important;
}
.actionsbuttons {
  margin-bottom: 20px;
}
</style>
